<script setup>
import { ref } from "vue";
import { hostname } from "../utils/host.js";

defineProps({
  visible: Boolean,
  toggleCameraAccessModal: Function
});

const confirmed = ref(false);

const handleReload = () => {
  window.location.reload();
};
</script>

<template>
<div v-if="visible" class="fixed top-8 right-0 bottom-0 left-0 z-[9999] flex items-center justify-center overflow-y-auto bg-white">
  <div class="text_all flex max-h-dvh min-h-full flex-col gap-7 p-5">
    <h1 class="text-center text-2xl font-bold">
      {{ $t("camera_access.title") }}
    </h1>
    <div class="flex flex-col gap-8">
      <div class="flex items-center gap-3">
        <img class="shrink-0" src="../assets/icons/settings.svg" alt="" />
        <p class="flex-1">
          <bdi>
            1.
          </bdi> <span v-html="$t('camera_access.camera_access_browser', { domain: hostname })"></span>
        </p>
      </div>
      <div class="self-stretch outline-1 outline-offset-[-0.50px] outline-black/10"></div>

      <div class="flex items-center gap-3">
        <img class="shrink-0" src="../assets/icons/gears.svg" alt="" />
        <p class="flex-1">
          <bdi>
            2.
          </bdi> <span v-html="$t('camera_access.camera_access_phone_setting')"></span>
        </p>
      </div>
      <div class="self-stretch outline-1 outline-offset-[-0.50px] outline-black/10"></div>

      <div class="flex items-center gap-3">
        <img class="shrink-0" src="../assets/icons/cameraClose.svg" alt="" />
        <p class="flex-1">
          <bdi>
            3.
          </bdi> <span v-html="$t('camera_access.close_other_apps')"></span>
        </p>
      </div>

    </div>
    <div class="flex flex-col items-center gap-2.5 py-6">
      <div class="flex w-full items-center gap-2">
        <input id="confirm-steps" v-model="confirmed" type="checkbox" class="h-5 w-5 shrink-0 accent-black" />
        <label for="confirm-steps" class="text-sm">
          {{ $t("camera_access.confirm_completed") }}
        </label>
      </div>
      <button
        class="inline-table rounded p-2.5 text-lg leading-none font-bold disabled:cursor-not-allowed"
        :class="confirmed ? 'bg-[var(--primary)] text-[var(--text-button)]' : 'bg-black/40 text-white'"
        :disabled="!confirmed"
        @click="handleReload()"
      >
        {{ $t("try_again") }}
      </button>
    </div>
  </div>
</div>
</template>
